module.exports = __webpack_public_path__ + "media/images/ticket_03-c04ded2d097fa1bd6d517f523a77ae98.png";